module.exports = __webpack_public_path__ + "img/image5.ad652104.png";